/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Strothoff_International_School4Inputs */

const en__field__enum_schoolname_strothoff_international_school4 = /** @type {(inputs: _Field__Enum_Schoolname_Strothoff_International_School4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dreieich`)
};

const de__field__enum_schoolname_strothoff_international_school4 = /** @type {(inputs: _Field__Enum_Schoolname_Strothoff_International_School4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strothoff International School`)
};

/**
* | output |
* | --- |
* | "Dreieich" |
*
* @param {_Field__Enum_Schoolname_Strothoff_International_School4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_strothoff_international_school4 = /** @type {((inputs?: _Field__Enum_Schoolname_Strothoff_International_School4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Strothoff_International_School4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_strothoff_international_school4(inputs)
	return de__field__enum_schoolname_strothoff_international_school4(inputs)
});
export { _field__enum_schoolname_strothoff_international_school4 as "_field__enum_schoolName_Strothoff_International_School" }